import {
  DynamicField,
  DynamicForm,
  FieldVariant,
  SwitchFieldProps,
  TextFieldProps
} from '@/components/form-builder/form-builder.types';
import { DynaDocsModelRepository } from '@/store/dyna-docs-model-state/dyna-docs-model-state.repository';
import {DynaStatus} from '@/types';
import {map} from 'rxjs';

interface Props {
  store: DynaDocsModelRepository;
}

export const getDynaDocsModelFormObject = ({ store }: Props): DynamicForm => {
  const descriptionField: DynamicField<TextFieldProps> = {
    label: 'settings.dynaDocsModels.form.description.label',
    variant: FieldVariant.TEXT,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'description'),
    props: {
      value: store.getNestedObservable<string>('dto', 'description'),
      onChange: (value: string) => {
        store.setNestedWithComparison('dto', 'description', value);
        store.setNested('errors', 'description', '');
      },
    },
  };
  const statusField: DynamicField<SwitchFieldProps> = {
    label: 'settings.dynaDocsModels.table.status',

    variant: FieldVariant.SWITCH,

    props: {
      checked: store
        .getNestedObservable<DynaStatus>('dto', 'status')
        .pipe(
          map((value: DynaStatus) => value === DynaStatus.ACTIF)
        ),

      onChange: (event: any) => {
        store.setNestedWithComparison(
          'dto',
          'status',
          event.checked
            ? DynaStatus.ACTIF
            : DynaStatus.NON_ACTIF
        );
      },
    },
  };
  return {
    title: 'settings.dynaDocsModels.form.title',
    description: '',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [descriptionField],
          },
          {
            fields: [statusField],
          },
        ],      },
    ],
  };
};
